module.exports = __webpack_public_path__ + "static/media/ok.41cb47f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ok.mp3
// module id = lFyW
// module chunks = 61